/* eslint-disable no-prototype-builtins */
/* eslint-disable complexity */
import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validDateOfFlight(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: unknown } | null => {
    if (control && control.touched && control.value) {
      if (control.value.value !== '') {
        let val = '';

        if (control.value.hasOwnProperty('value')) {
          val = control.value.value;
        } else {
          val = control.value;
        }

        return !val.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)
          ? {
              dateOfFlight: {
                value: val,
                match: '/^d{1,2}/d{1,2}/d{4}$/'
              }
            }
          : null;
      } else {
        return null;
      }
    }
    return null;
  };
}
export function futureOrPrevousDateCheck(
  month: string,
  day: string,
  year: string,
  futureDate: boolean
): ValidatorFn {
  return (): { [key: string]: unknown } | null => {
    if (month && day && year) {
      const dayValue = day.toString().length > 1 ? day : `${'0'}${day}`;
      const monthValue = month.toString().length > 1 ? month : `${'0'}${month}`;
      const cmpdateOfBirth = `${year}-${monthValue}-${dayValue}${'T00:00:00'}`;
      const enteredCmpDobDate = new Date(cmpdateOfBirth);
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      if (futureDate) {
        if (enteredCmpDobDate > todayDate) {
          return {
            futureDateNotAllowed: true
          };
        }
      } else {
        if (enteredCmpDobDate < todayDate) {
          return {
            prevousDateNotAllowed: true
          };
        }
      }
    } else {
      return null;
    }
    return null;
  };
}
